import { createGlobalStyle, css } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    background-color: #f8f8f8;
    color: #000;
  }
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      body {
        background-color: #161b21;
        color: #f0f0f0;
      }
    `}

`;
